import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slice/authSlice";
import { useDispatch } from "react-redux";

const SignOut = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const signOut = () => {
      // Clear ALL auth data synchronously, including refreshToken — leaving
      // it behind was a real bug: the axios response interceptor
      // (redux/slice/apiAuth.js) sees any 401 fired during this window,
      // finds a still-present refreshToken, and silently refreshes a brand
      // new access token right in the middle of logging out, re-writing
      // "token" back into localStorage a moment after it was removed.
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      dispatch(logout());
      navigate("/");
    };

    signOut();
  }, [dispatch, navigate]);

  return (
    <>
      <h1>Signing Out ... </h1>
    </>
  );
};

export default SignOut;
